(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-blog-posts"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
  class YGBlogPosts extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
    }

    connectedCallback() {
      this.initSwiper();
      this.initTimelineInteraction();
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    initSwiper() {
      this.swiperInstance = new Swiper(this, {
        spaceBetween: 6, 
        slidesPerView: 1.4,
        breakpoints: { 
          700: { 
            spaceBetween: 12, 
            slidesPerView: 3, 
          }, 
        }
      });

    }

  }

  if (!customElements.get('yg-blog-posts')) {
    customElements.define('yg-blog-posts', YGBlogPosts);
  }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-icon-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  class YGIconSwiper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.swiper = new Swiper(this, {
        slidesPerView: 'auto',
        spaceBetween: 12,
      });
    }
  }

  if (!window.customElements.get('yg-icon-swiper')) {
    window.customElements.define('yg-icon-swiper', YGIconSwiper);
  }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-banner-swiper"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    class YGProductBanners extends HTMLElement {
      constructor() {
        super();
        this.swiperInstance = null;
      }

      connectedCallback() {
        this.initSwiper();
        this.initTimelineInteraction();
      }

      disconnectedCallback() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      initSwiper() {
        this.prevBtn = this.querySelector('.swiper-button-prev');
        this.nextBtn = this.querySelector('.swiper-button-next');

        this.swiperInstance = new Swiper(this, {
          spaceBetween: 0, 
          slidesPerView: 1.1,
          breakpoints: { 
            700: {
              slidesPerView: 1.4, 
            }, 
          },
          navigation: { 
            nextEl: this.nextBtn, 
            prevEl: this.prevBtn, 
          }
        });

      }

    }

    if (!customElements.get('yg-product-banners')) {
      customElements.define('yg-product-banners', YGProductBanners);
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-video-swiper"] && !Shopify.designMode) return;
  try {
    
  class YGVideoPopup extends YGUtils {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
      // 在初始化 swiper 后设置可见性自动播放（视口内自动播放第一个）
      this.initAutoPlayOnVisible();
    }

    disconnectedCallback() {
      // 清理 Swiper 实例（如果存在）
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
      // 清理可见性观察器
      try {
        if (this.visibilityObserver && typeof this.visibilityObserver.disconnect === 'function') {
          this.visibilityObserver.disconnect();
          this.visibilityObserver = null;
        }
      } catch (e) {}
    }

    initSwiper() {
      this.prevBtn = this.querySelector('.swiper-button-prev');
      this.nextBtn = this.querySelector('.swiper-button-next');

      this.swiperInstance = new Swiper(this.querySelector('.swiper'), {
        navigation: {
          nextEl: this.nextBtn,
          prevEl: this.prevBtn,
        },
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          type: "progressbar",
        },
        breakpoints: {
          100: {
            spaceBetween: 12,
            slidesPerView: 1.2,
          },
          700: {
            spaceBetween: 12,
            slidesPerView: 4,
          }
        },
        on: {
          init: e => {
            if (e.passedParams.loop && e.slides.length < 5) {
              e.slides.forEach(slide => {
                const clonedElement = slide.cloneNode(true);
                e.slidesEl.appendChild(clonedElement);
              })
            }
          },
          slideChange: (swiper) => {
            // 当用户手动切换 slide 时，自动播放对应索引的视频
            const activeIndex = swiper.activeIndex;
            this.playIndex(activeIndex);
          }
        }
      });
      
      // 初始化播放列表控制器（不自动播放，点击开始）
      this.initPlaylist();
    }

    /**
     * 初始化播放列表：收集每一张 slide 中的 yg-video 与 progress 元素，
     * 并绑定点击以启动播放、以及播放结束后自动播放下一个的逻辑
     */
    initPlaylist() {
      this.playItems = [];
      const slides = Array.from(this.querySelectorAll('.swiper-slide'));
      slides.forEach((slide, idx) => {
        const ygVideoEl = slide.querySelector('yg-video');
        const progressContainer = slide.querySelector('.yg-play-progress');
        const progressFill = progressContainer?.querySelector('.yg-play-progress__fill');

        const item = {
          slide,
          ygVideoEl,
          progressContainer,
          progressFill,
          ytPlayer: null,
          htmlVideoEl: null,
          progressInterval: null
        };

        // 初始隐藏进度条，只有播放时显示
        if (item.progressContainer) {
          item.progressContainer.style.display = 'none';
        }
        // 初始确保没有 playing 状态
        try { const vcInit = slide.querySelector('.yg-video-container'); if (vcInit) vcInit.classList.remove('playing'); } catch(e){}

        this.playItems.push(item);

        if (ygVideoEl) {
          // 点击任意 yg-video 元素直接触发播放（覆盖弹窗逻辑）
          ygVideoEl.addEventListener('click', (e) => {
            // prevent the anchor link in product overlay from navigating if click comes from video area
            e.stopPropagation();
            e.preventDefault();
            this.playIndex(idx);
          });
        }
        // 初始隐藏进度条与音量按钮，只有播放时显示
        if (item.progressContainer) {
          item.progressContainer.style.display = 'none';
        }
        const itemVolBtn = slide.querySelector('.yg-volume-control');
        if (itemVolBtn) itemVolBtn.style.display = 'none';
        // 绑定音量控制按钮（如果存在）
        const volBtn = slide.querySelector('.yg-volume-control');
        if (volBtn) {
          volBtn.addEventListener('click', (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            const mutedIcon = volBtn.querySelector('.volume-icon.muted');
            const unmutedIcon = volBtn.querySelector('.volume-icon.unmuted');

            const videoEl = slide.querySelector('video');
            if (videoEl) {
              videoEl.muted = !videoEl.muted;
              if (videoEl.muted) {
                if (mutedIcon) mutedIcon.style.display = 'block';
                if (unmutedIcon) unmutedIcon.style.display = 'none';
              } else {
                if (mutedIcon) mutedIcon.style.display = 'none';
                if (unmutedIcon) unmutedIcon.style.display = 'block';
              }
              return;
            }

            const iframeEl = slide.querySelector('.yg-youtube-player');
            if (iframeEl) {
              const itemRef = this.playItems[idx];
              const player = itemRef?.ytPlayer;
              if (player && typeof player.isMuted === 'function') {
                if (player.isMuted()) {
                  player.unMute();
                  if (mutedIcon) mutedIcon.style.display = 'none';
                  if (unmutedIcon) unmutedIcon.style.display = 'block';
                } else {
                  player.mute();
                  if (mutedIcon) mutedIcon.style.display = 'block';
                  if (unmutedIcon) unmutedIcon.style.display = 'none';
                }
              } else {
                try {
                  iframeEl.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
                  if (mutedIcon) mutedIcon.style.display = 'none';
                  if (unmutedIcon) unmutedIcon.style.display = 'block';
                } catch (e) {}
              }
            }
          });
        }
      });

      this.currentIndex = -1;
    }

    /**
     * 当本组件进入视口时自动播放第一个视频（只触发一次）
     */
    initAutoPlayOnVisible() {
      try {
        if (this.visibilityObserver) return;
        this.autoplayTriggered = false;
        this.visibilityObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            // 使用较高阈值避免小部分可见即触发
            if (entry.isIntersecting && entry.intersectionRatio > 0.4) {
              if (!this.autoplayTriggered && this.currentIndex === -1) {
                this.autoplayTriggered = true;
                // 播放第一个元素
                this.playIndex(0);
                // 触发一次后断开观察，避免重复自动播放
                try { this.visibilityObserver.disconnect(); } catch(e) {}
                this.visibilityObserver = null;
              }
            }
          });
        }, { threshold: [0.25, 0.5, 0.75] });

        this.visibilityObserver.observe(this);
      } catch (err) {
        // ignore in environments without IntersectionObserver
      }
    }

    /**
     * 播放索引为 index 的项
     */
    async playIndex(index) {
      if (!Array.isArray(this.playItems) || this.playItems.length === 0) return;
      if (index < 0) index = 0;
      index = index % this.playItems.length;

      // 如果已经是正在播放的索引，则直接忽略
      if (this.currentIndex === index) return;

      // 停止当前播放（如果有）并恢复未播放状态（隐藏进度条、显示占位图、重置时间）
      if (this.currentIndex !== -1) {
        const cur = this.playItems[this.currentIndex];
        if (cur) {
          // 优先调用封装好的 pauseVideo 恢复占位图与移除 iframe/video 容器
          try {
            if (cur.ygVideoEl && typeof cur.ygVideoEl.pauseVideo === 'function') {
              cur.ygVideoEl.pauseVideo();
            }
          } catch (err) {}

          // 另外确保 html/video / yt player 停止并移除轮询
          try {
            if (cur.htmlVideoEl && typeof cur.htmlVideoEl.pause === 'function') {
              cur.htmlVideoEl.pause();
              cur.htmlVideoEl.currentTime = 0;
            }
          } catch (err) {}

          try {
            if (cur.ytPlayer && typeof cur.ytPlayer.pauseVideo === 'function') {
              cur.ytPlayer.pauseVideo();
            }
          } catch (err) {}

          if (cur.progressInterval) {
            clearInterval(cur.progressInterval);
            cur.progressInterval = null;
          }

          // 隐藏并重置进度条
          try {
            if (cur.progressFill) cur.progressFill.style.width = '0%';
            if (cur.progressContainer) cur.progressContainer.style.display = 'none';
            // 隐藏对应 slide 的音量按钮
            try {
              const curVol = cur.slide?.querySelector('.yg-volume-control');
              if (curVol) curVol.style.display = 'none';
            } catch(e){}
            // 移除 playing 状态（显示 ::before overlay）
            try { const vc = cur.slide?.querySelector('.yg-video-container'); if (vc) vc.classList.remove('playing'); } catch(e){}
          } catch (err) {}

          // 清理播放器实例引用
          cur.htmlVideoEl = null;
          cur.ytPlayer = null;
        }
      }

      this.currentIndex = index;
      const item = this.playItems[index];
      if (!item) return;

      // 将 swiper 滑至该页（以便可见）
      if (this.swiperInstance && typeof this.swiperInstance.slideTo === 'function') {
        this.swiperInstance.slideTo(index);
      }

      // 显示当前项的进度条并触发 yg-video 的播放（内部会 append 模板或播放 video）
      if (item.progressContainer) {
        item.progressContainer.style.display = '';
        // 显示对应 slide 的音量按钮
        try {
          const volBtnToShow = item.slide?.querySelector('.yg-volume-control');
          if (volBtnToShow) volBtnToShow.style.display = 'flex';
        } catch(e){}
        // 标记 yg-video-container 为 playing（隐藏 ::before 内容遮罩）
        try { const vc2 = item.slide?.querySelector('.yg-video-container'); if (vc2) vc2.classList.add('playing'); } catch(e){}
      }
      if (item.progressFill) {
        item.progressFill.style.width = '0%';
      }

      // 触发 yg-video 的播放（内部会 append 模板或播放 video）
      if (item.ygVideoEl && typeof item.ygVideoEl.playVideo === 'function') {
        try { item.ygVideoEl.playVideo(); } catch(err) {}
      } else if (item.ygVideoEl) {
        // 若没有 playVideo 方法，则模拟点击内部按钮
        const btn = item.ygVideoEl.querySelector('.yg-play-video');
        btn?.click();
      }

      // 等待元素插入/播放开始后再查找真实的 video/iframe 元素并绑定事件
      setTimeout(() => {
        const videoContainer = item.ygVideoEl?.querySelector('.yg-video-iframe-container');
        if (!videoContainer) return;
        const mediaEls = Array.from(videoContainer.querySelectorAll('.yg-video-iframe'));
        // 优先处理 html5 video
        const htmlVideo = mediaEls.find(e => e.tagName === 'VIDEO');
        if (htmlVideo) {
          item.htmlVideoEl = htmlVideo;
          // 绑定 timeupdate 与 ended
          htmlVideo.addEventListener('timeupdate', () => {
            const dur = htmlVideo.duration || 0;
            const cur = htmlVideo.currentTime || 0;
            const pct = dur > 0 ? (cur / dur) * 100 : 0;
            if (item.progressFill) item.progressFill.style.width = pct + '%';
          });
          htmlVideo.addEventListener('ended', () => {
            // 视频结束时先短暂显示完成，再恢复未播放状态
            try { if (item.progressFill) item.progressFill.style.width = '100%'; } catch(e){}
            try { if (item.ygVideoEl && typeof item.ygVideoEl.pauseVideo === 'function') item.ygVideoEl.pauseVideo(); } catch(e){}
            try { if (item.progressFill) item.progressFill.style.width = '0%'; } catch(e){}
            try { if (item.progressContainer) item.progressContainer.style.display = 'none'; } catch(e){}
            // 隐藏结束视频的音量按钮
            try { const vb = item.slide?.querySelector('.yg-volume-control'); if (vb) vb.style.display = 'none'; } catch(e){}
            // 移除 playing 状态（显示 ::before overlay）
            try { const vc3 = item.slide?.querySelector('.yg-video-container'); if (vc3) vc3.classList.remove('playing'); } catch(e){}
            this.playNext();
          });
        } else {
          // 处理 iframe（尝试支持 YouTube）
          const iframe = mediaEls.find(e => e.tagName === 'IFRAME');
          if (iframe && iframe.src && iframe.src.indexOf('youtube.com') !== -1) {
            // 确保 YouTube API 已加载
            this.ensureYouTubeApi().then(() => {
              try {
                item.ytPlayer = new YT.Player(iframe, {
                  events: {
                    onStateChange: (ev) => {
                      // PLAYING
                      if (ev.data === YT.PlayerState.PLAYING) {
                        // 开始轮询进度
                        if (item.progressInterval) clearInterval(item.progressInterval);
                        item.progressInterval = setInterval(() => {
                          try {
                            const cur = item.ytPlayer.getCurrentTime();
                            const dur = item.ytPlayer.getDuration();
                            const pct = dur > 0 ? (cur / dur) * 100 : 0;
                            if (item.progressFill) item.progressFill.style.width = pct + '%';
                          } catch(err) {}
                        }, 250);
                      }
                      // ENDED
                      if (ev.data === YT.PlayerState.ENDED) {
                        try { if (item.progressFill) item.progressFill.style.width = '100%'; } catch(e){}
                        try { if (item.ygVideoEl && typeof item.ygVideoEl.pauseVideo === 'function') item.ygVideoEl.pauseVideo(); } catch(e){}
                        try { if (item.progressFill) item.progressFill.style.width = '0%'; } catch(e){}
                        try { if (item.progressContainer) item.progressContainer.style.display = 'none'; } catch(e){}
                        // 隐藏结束视频的音量按钮
                        try { const vb2 = item.slide?.querySelector('.yg-volume-control'); if (vb2) vb2.style.display = 'none'; } catch(e){}
                        // 移除 playing 状态（显示 ::before overlay）
                        try { const vc4 = item.slide?.querySelector('.yg-video-container'); if (vc4) vc4.classList.remove('playing'); } catch(e){}
                        // 清理 YT 轮询
                        if (item.progressInterval) { clearInterval(item.progressInterval); item.progressInterval = null; }
                        this.playNext();
                      }
                    }
                  }
                });
              } catch (err) {
                // 如果无法创建 player，则退回到点击后等待的简单轮询（尽量更新一次）
                if (item.progressFill) item.progressFill.style.width = '0%';
              }
            }).catch(() => {
              // ignore
            });
          }
        }
      }, 300);
    }

    playNext() {
      if (!this.playItems || this.playItems.length === 0) return;
      const next = (this.currentIndex + 1) % this.playItems.length;
      this.playIndex(next);
    }

    ensureYouTubeApi() {
      return new Promise((resolve) => {
        if (window.YT && window.YT.Player) return resolve();
        // 如果已经正在加载，监听回调
        if (window._ygYouTubeLoading) {
          const check = setInterval(() => {
            if (window.YT && window.YT.Player) {
              clearInterval(check);
              resolve();
            }
          }, 100);
          return;
        }
        window._ygYouTubeLoading = true;
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        // onYouTubeIframeAPIReady will be called by YouTube
        const orig = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = function() {
          if (typeof orig === 'function') orig();
          resolve();
        };
      });
    }
  }

  if (!window.customElements.get('yg-video-popup')) {
    window.customElements.define('yg-video-popup', YGVideoPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  class YGReviews extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
    }

    connectedCallback() {
      this.initSwiper();
      this.initTimelineInteraction();
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    initSwiper() {
      this.prevBtn = this.querySelector('.swiper-button-prev');
      this.nextBtn = this.querySelector('.swiper-button-next');

      this.swiperInstance = new Swiper(this.querySelector('.swiper'), {
        spaceBetween: 12, 
        slidesPerView: 1,
        breakpoints: { 
          700: { 
            spaceBetween: 12, 
            slidesPerView: 2, 
          }, 
        },
        navigation: { 
          nextEl: this.nextBtn, 
          prevEl: this.prevBtn, 
        },
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          type: "progressbar",
        }
      });

    }

  }

  if (!customElements.get('yg-reviews')) {
    customElements.define('yg-reviews', YGReviews);
  }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-scroll-image"] && !Shopify.designMode) return;
  try {
    
    class YGScrollImage extends HTMLElement {
    constructor() {
        super();
        this._init();
    }

    _init() {
        const sectionId = this.getAttribute("data-section-id");
        if (!sectionId) return;

        // 等待图片加载完成后再计算
        this._waitForImages().then(() => {
        this._calculateAnimation();
        });

        // 监听窗口大小变化
        if (window.ResizeObserver) {
        new ResizeObserver(() => {
            this._calculateAnimation();
        }).observe(this);
        }

        // 鼠标悬停暂停/恢复
        const container = document.getElementById(`yg-scrolling-container-${sectionId}`);
        if (container) {
        container.addEventListener('mouseenter', () => this._pauseScrolling());
        container.addEventListener('mouseleave', () => this._resumeScrolling());
        }
    }

    _waitForImages() {
        return new Promise((resolve) => {
        const images = this.querySelectorAll('yg-image img, yg-image svg');
        if (images.length === 0) {
            resolve();
            return;
        }

        let loadedCount = 0;
        const totalImages = images.length;

        const checkComplete = () => {
            loadedCount++;
            if (loadedCount >= totalImages) {
            // 额外等待一小段时间确保布局稳定
            setTimeout(resolve, 100);
            }
        };

        images.forEach((img) => {
            if (img.complete) {
            checkComplete();
            } else {
            img.addEventListener('load', checkComplete, { once: true });
            img.addEventListener('error', checkComplete, { once: true });
            }
        });
        });
    }

    _calculateAnimation() {
        const scrollingSpeed = parseFloat(this.getAttribute("scrolling-speed") || 45);
        const sectionId = this.getAttribute("data-section-id");
        
        // 获取第一个滚动元素的宽度
        const firstElement = this;
        const elementWidth = firstElement.offsetWidth;
        
        if (elementWidth === 0) {
        // 如果宽度为0，延迟重试
        setTimeout(() => this._calculateAnimation(), 100);
        return;
        }

        // 获取两个元素之间的 gap（从父元素获取）
        const listElement = document.getElementById(`yg-scrolling-list-${sectionId}`);
        const computedStyle = window.getComputedStyle(listElement);
        const gap = parseFloat(computedStyle.gap) || 0;
        
        // 动画移动的距离 = 元素宽度 + gap（这样第二个元素才能无缝接上）
        const moveDistance = elementWidth + gap;

        // 计算动画时长：速度越大，移动越快（时长越短）
        // scrollingSpeed 表示每秒移动的像素数
        const duration = moveDistance / scrollingSpeed;

        // 设置CSS变量
        this.style.setProperty('--marquee-width', `${moveDistance}px`);
        this.style.setProperty('--marquee-duration', `${duration}s`);

        // 确保所有元素使用相同的动画参数
        const allElements = document.querySelectorAll(`yg-scroll-image[data-section-id="${sectionId}"]`);
        allElements.forEach((el) => {
        if (el !== this) {
            el.style.setProperty('--marquee-width', `${moveDistance}px`);
            el.style.setProperty('--marquee-duration', `${duration}s`);
        }
        });
    }

    _pauseScrolling() {
        const sectionId = this.getAttribute("data-section-id");
        const allElements = document.querySelectorAll(`yg-scroll-image[data-section-id="${sectionId}"]`);
        allElements.forEach((item) => {
        item.style.animationPlayState = 'paused';
        });
    }

    _resumeScrolling() {
        const sectionId = this.getAttribute("data-section-id");
        const allElements = document.querySelectorAll(`yg-scroll-image[data-section-id="${sectionId}"]`);
        allElements.forEach((item) => {
        item.style.animationPlayState = 'running';
        });
    }
    }

    if (!window.customElements.get("yg-scroll-image")) {
    window.customElements.define("yg-scroll-image", YGScrollImage);
    }

  } catch(e) { console.error(e); }
})();
})();
